import { useFDAChangeManagementFlow } from "../../../hooks/useFDAChangeManagementFlow";
import { questions } from "../../../utils/Questions";

const ChangeManagementInit = () => {
  const [answerQuestion] = useFDAChangeManagementFlow();

  return (
    <div className="flex h-full items-center justify-center">
      <div className="grid grid-cols-2 gap-4">
        {questions.slice(0, 4).map((item) => (
          <div
            key={item.code}
            className="rounded-box flex w-full max-w-xs cursor-pointer items-center justify-center bg-gray-300 p-2 text-sm hover:bg-gray-500 hover:text-gray-300"
            onClick={() => answerQuestion({ question: item, answer: "yes" })}
          >
            <span className="text-center text-2xl">{item.question}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ChangeManagementInit;
